import React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import { getArtistPlanSignupSent } from '@disco/state-management/selectors/user'
import { getRootPath } from '@disco/utils/pricing'
import ArtistVerificationSuccessModal from 'components/modals/artist-verification-modal/success'
import ModalDialog from 'components/ui/modal-dialog'

const ArtistVerificationApplyModal = (): React.ReactNode => {
  const location = useLocation()
  const navigate = useNavigate()
  const rootPath = getRootPath(location)
  const dispatch = useDispatch()
  const signupSent = useSelector(getArtistPlanSignupSent)

  const onSubmit = () => {
    navigate(`${rootPath}/artist-signup`)
  }

  const onCancel = () => {
    navigate(rootPath)
  }

  if (signupSent) {
    return <ArtistVerificationSuccessModal rootPath={rootPath} />
  }

  return (
    <ModalDialog
      title="Artist Plan"
      primaryAction={{
        caption: 'Apply',
        onClick: onSubmit,
      }}
      onCancel={onCancel}
    >
      Our artist plan is designed for artists, songwriters, bands and producers.
      See full feature list{' '}
      <a
        className="text-link"
        href="https://www.disco.ac/artist-plan-comparison"
        target="_blank"
        rel="noopener noreferrer"
      >
        here.
      </a>
    </ModalDialog>
  )
}

export default ArtistVerificationApplyModal
